import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";

import { Button, Modal } from "cai-fusion";
import { useSiftV2 } from "../../../contexts/siftV2Context";
import { useNavigate } from "react-router-dom";

const DeleteOpportunityModal = () => {
    const { visibilityStates, hide } = useTransientVisibility();
    const navigate = useNavigate();
    const { currOpp } = useSiftV2();

    return (
        <Modal
            id="delete-modal"
            isHidden={ !visibilityStates.DeleteOpportunityModal }
            clickOutsideToClose={ true }
            title="Delete Opportunity"
            onClose={(e) => {
                hide('DeleteOpportunityModal');
                e.preventDefault();
            }}
            actions={
                <>
                    <Button outline onClick={(e) => { e.preventDefault(); hide('DeleteOpportunityModal'); }} children="Cancel"/>
                    <Button danger onClick={(e) => { e.preventDefault(); hide('DeleteOpportunityModal'); navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}`); }} children="Delete Opportunity"/>
                </>
            }
        >
            <div className="l-row">
                <div className="l-one-col">
                    <p><strong>{`Are you sure you want to delete ${currOpp?.name ? (`"` + currOpp?.name + `"`) : "this opportunity"}?`}</strong></p>
                    <p>This will "soft-delete" this opportunity, meaning it can be restored by an administrator for 30 days before being completely wiped.</p>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteOpportunityModal;